export default __webpack_public_path__ + "static/media/gs8-ha-upgrade-modal.71dbe986.png";